<ft-literature-dialog
  [modalIdEnum]="ModalId['Dashboard_Cart_Modal']"
  [dialogId]="ModalId['Cart_Modal']"
  [gridData]="dialogData"
  (dialog)="closeDialog($event)"
  (deleteCartDoc)="updateStorage($event)"
  (modalClose)="closeDialog(ModalId['Dashboard_Cart_Modal'])"
></ft-literature-dialog>

<ng-container *ngIf="profile$ | async as profile">
  <ng-container *ngIf="profile.isLoggedIn">
    <div *ngIf="literatureDocumentData === null">
      <div>
        <span [innerHTML]="'loading ...'"></span>
      </div>
    </div>
    <div *ngIf="literatureDocumentData">
      <eds-card-dashboard
        [card]="literatureCard"
        (btnSubscribe)="openHistoryPage($event)"
      >
        <eds-card-dashboard-literature
          [literatureTableProperties]="literatureTableProperties"
          [toggleButtons]="toggleButtons"
          [documentData]="literatureDocumentData"
          (btnAddToCart)="addToCart($event)"
          (btnDownloadDocument)="downloadDocument($event)"
        ></eds-card-dashboard-literature>
      </eds-card-dashboard>
    </div>
  </ng-container>
</ng-container>
